import { createHandle } from 'services/breadcrumbs/breadcrumbs';
import { BlockedTransactions } from '../BlockedTransactions/BlockedTransactions';
import { TransactionsRoutes } from 'support/types';
import { TFunction } from 'i18next';

export const ExpiredTransactions = () => {
  return <BlockedTransactions expired={true} />;
};

ExpiredTransactions.handle = createHandle(() => ({
  label: (t: TFunction) => t('transactions:list.expiredBreadcrumb'),
  to: TransactionsRoutes.expired,
  key: TransactionsRoutes.expired,
}));
